export default {
      id: "MD-orange-usage",
      viewBox: "0 0 19 17",
      url: __webpack_public_path__ + "img/icons.svg#MD-orange",
      toString: function () {
        return this.url;
      }
    }